/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

import {PureComponent, ReactElement} from 'react';

interface Props {
    children?: any;
}

export default class DVRHead extends PureComponent<Props> {

    private includeTags = () => {
        const {children} = this.props;
        this.removeAll();
        if (children) {
            if (Array.isArray(children)) for (const child of children) this.includeChild(child);
            else this.includeChild(children);
        }
    };

    private includeChild = (child: ReactElement<any>) => {
        const {type, props} = child,
            elem = document.createElement(type as keyof HTMLElementTagNameMap);
        for (const key of Object.keys(props)) {
            if (key === 'children') elem.innerHTML = props[key];
            else (elem as any)[key] = props[key];
        }
        elem.dataset.gen = 'dvr';
        document.head.appendChild(elem);
    };

    private removeAll = () => {
        const elems = document.querySelectorAll("[data-gen='dvr']");
        for (const elem of elems) elem.parentElement?.removeChild(elem);
    };

    componentDidMount = () => {
        this.includeTags();
    };

    componentDidUpdate = () => {
        this.includeTags();
    };

    render = () => {
        return null;
    }
}
